// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_routes_reports_reports_module_ts":"ec0cd19079f0e1ae","src_app_bulk-user-update_bulk-user-update_module_ts":"f6221114dba665de"}[chunkId] + ".js";
};